export default __webpack_public_path__ + "static/media/chat.3943aaf6.mov";